import GreenhouseSettings from "./GreenhouseSettings";

export default GreenhouseSettings;
